import { render, staticRenderFns } from "./AlarmLevelParamsTab.vue?vue&type=template&id=12e9f9be&scoped=true&"
import script from "./AlarmLevelParamsTab.vue?vue&type=script&lang=js&"
export * from "./AlarmLevelParamsTab.vue?vue&type=script&lang=js&"
import style0 from "./AlarmLevelParamsTab.vue?vue&type=style&index=0&id=12e9f9be&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e9f9be",
  null
  
)

export default component.exports